module.exports = __webpack_public_path__ + "static/media/spinner.9b1a847e.svg";